import { useMemo } from "react";
import { useDiscussions } from "hooks/useDiscussions";
import { useChatAvailability } from "hooks/useChatAvailability";
import { useAuthStore } from "stores/authStore";

export const useUnreadMessagesCount = () => {
  const currentUserId = useAuthStore(state => state.currentUserId);

  const isChatEnabled = useChatAvailability();

  const {
    discussions = [],
    isPending: discussionsIsLoading,
    isSuccess,
  } = useDiscussions({ enabled: isChatEnabled });

  const unreadMessagesCount = useMemo(() => {
    if (!isChatEnabled) return 0;
    if (discussionsIsLoading || !isSuccess) return 0;

    return discussions.reduce((acc, discussion) => {
      if (
        discussion.unreadMessageCount &&
        discussion.lastMessageCreatedBy !== currentUserId
      ) {
        return acc + discussion.unreadMessageCount;
      }
      return acc;
    }, 0);
  }, [
    isChatEnabled,
    discussions,
    discussionsIsLoading,
    isSuccess,
    currentUserId,
  ]);

  return { unreadMessagesCount, isChatEnabled };
};
